var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { ModalHeader } from "@irati-web/recognition/src/components/Popup/shared/Modal";
import { rewardTracking } from "@irati-tracking/reward";
import InnerReceipt from "./InnerReceipt";
import { StyledModal } from "./styled";
var Receipt = /** @class */ (function (_super) {
    __extends(Receipt, _super);
    function Receipt() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Receipt.prototype.componentDidMount = function () {
        var _a;
        if ((_a = this.props.rewardOrder.reward) === null || _a === void 0 ? void 0 : _a.isCredit) {
            rewardTracking.rewardsTabCreditSend();
        }
    };
    Receipt.prototype.render = function () {
        var _a = this.props, buttonText = _a.buttonText, onClose = _a.onClose, rewardOrder = _a.rewardOrder;
        return (React.createElement(StyledModal, { show: true, useMobileStyling: false, onHide: onClose, onExited: onClose, renderHeader: function (_a) {
                var size = _a.size;
                return React.createElement(ModalHeader, { users: rewardOrder.recipients.results, size: size });
            } },
            React.createElement(InnerReceipt, { rewardOrder: rewardOrder, onClose: onClose, buttonText: buttonText })));
    };
    return Receipt;
}(Component));
export default Receipt;
